const ENDPOINT = 'https://theonlybean.myshopify.com/api/2026-07/graphql.json';
const PUBLIC_STOREFRONT_TOKEN = 'a54f56d1173c00b888d6932852f9f394';
const gid = (kind, id) => `gid://shopify/${kind}/${id}`;
export const FLAVORS = ['45056427655351', '45056427753655', '45056427786423', '45056427720887', '45056427688119'];
export const GIFTS = [
  { minimum: 2, id: '45131346247863', value: 5.99 },
  { minimum: 3, id: '45283003203767', value: 5.95 },
  { minimum: 4, id: '38115716038839', value: 7.99 },
  { minimum: 6, id: '45133595279543', value: 39.99 },
];
const ONCE_CODES = ['1BOX_10','2BOX_15','3BOX_15','4BOX_20','5BOX_22','6BOX_27','7BOX_32','8BOX_37','9BOX_40','10BOX_40'];
export const sellingPlan = (quantity) => gid('SellingPlan', quantity < 4 ? '1776156855' : quantity < 6 ? '1776189623' : '1776222391');
export function buildCartInput(selection, mode, minimum = 2, attributes = []) {
  const entries = Object.entries(selection).filter(([, quantity]) => quantity > 0);
  if (entries.some(([id, n]) => !FLAVORS.includes(id) || !Number.isInteger(n))) throw new Error('Invalid flavor selection.');
  const quantity = entries.reduce((sum, [, n]) => sum + n, 0);
  const once = mode === 'once';
  if (quantity < (once ? 1 : minimum) || quantity > (once ? Number.MAX_SAFE_INTEGER : 10)) throw new Error('Choose the required number of boxes.');
  const lines = entries.map(([id, n]) => ({ merchandiseId: gid('ProductVariant', id), quantity: n, ...(!once && { sellingPlanId: sellingPlan(quantity) }) }));
  if (!once) GIFTS.filter(g => quantity >= g.minimum).forEach(g => lines.push({ merchandiseId: gid('ProductVariant', g.id), quantity: 1 }));
  const discountCodes = once ? [ONCE_CODES[Math.min(quantity, 10) - 1]] : ['LP008_GIFTS', `${quantity}PK008`];
  if (quantity >= 3) discountCodes.push('FREE_S');
  return { lines, discountCodes, buyerIdentity: { countryCode: 'US' }, attributes: [...attributes, { key: 'totalBoxes', value: String(quantity) }, { key: 'offer', value: once ? 'byob-onetime' : 'bundle-builder-with-gifts' }] };
}
export function validateCart(cart, input) {
  if (!cart?.checkoutUrl || cart.cost?.totalAmount?.currencyCode !== 'USD') throw new Error('Unable to confirm your order total. Please try again.');
  const lines = cart.lines.nodes;
  if (lines.length !== input.lines.length) throw new Error('An item is unavailable. Please adjust your flavors and try again.');
  for (const expected of input.lines) {
    const actual = lines.find(line => line.merchandise.id === expected.merchandiseId);
    if (!actual || actual.quantity !== expected.quantity || (actual.sellingPlanAllocation?.sellingPlan.id || null) !== (expected.sellingPlanId || null)) throw new Error('Your selection could not be confirmed. Please try again.');
    if (GIFTS.some(g => gid('ProductVariant', g.id) === expected.merchandiseId) && Number(actual.cost.totalAmount.amount) > 0) throw new Error('Your free gift discount could not be applied. Please try again.');
  }
  for (const code of input.discountCodes.filter(code => code !== 'FREE_S')) {
    if (!cart.discountCodes.some(d => d.code.toUpperCase() === code && d.applicable)) throw new Error('Your offer discount could not be applied. Please try again.');
  }
  return cart;
}
const CART_CREATE = `mutation FlavorCart($input: CartInput!) {
  cartCreate(input: $input) {
    cart { id checkoutUrl cost { totalAmount { amount currencyCode } }
      discountCodes { code applicable }
      lines(first: 20) { nodes { quantity merchandise { ... on ProductVariant { id } } cost { totalAmount { amount currencyCode } } sellingPlanAllocation { sellingPlan { id name } } } }
    }
    userErrors { field message }
  }
}`;
const CATALOG = `query FlavorAvailability($ids: [ID!]!) {
  nodes(ids: $ids) { ... on ProductVariant { id availableForSale } }
}`;
async function request(query, variables) {
  const response = await fetch(ENDPOINT, {
    method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': PUBLIC_STOREFRONT_TOKEN },
    body: JSON.stringify({ query, variables }), signal: AbortSignal.timeout(15000),
  });
  const payload = await response.json();
  if (!response.ok || payload.errors?.length) throw new Error('We couldn’t connect to checkout. Please try again.');
  return payload.data;
}

const TOTALS = {2:28.34,3:42.51,4:56,5:70,6:79.26,7:92.47,8:105.68,9:118.89,10:132.10};
const COMPARE = {2:43.41,3:68.07,4:94.77,5:113.48,6:172.18,7:190.89,8:209.60,9:228.31,10:247.02};
const SAVINGS = {2:21,3:38,4:41,5:38,6:54,7:52,8:50,9:48,10:47};
export function selectionState(count, minimum, once) {
  const valid = count >= (once ? 1 : minimum);
  return {
    valid,
    label: once ? (valid ? 'Order now' : 'Select at least 1 box') : (valid ? 'Proceed to checkout' : `Select at least ${minimum} boxes`),
    counter: valid ? String(count) : `${count}/${minimum}`,
    displayQuantity: Math.max(count, minimum),
  };
}
const INGREDIENTS = {
  seasalt: 'Edamame, Sea Salt, Soybean Oil',
  sriracha: 'Edamame, Soybean Oil, Salt, Garlic Powder, Chili Powder, Sugar, Onion Powder, Pepper Extract, Sweet Pepper Powder, Citric Acid',
  buffalo: 'Edamame, Buffalo City Roasted Wing Flavor (Cayenne Pepper, Distilled Vinegar, Garlic, Yeast Extract, Cane Sugar, Citric Acid, Paprika Extract, Natural Non-Dairy Butter), Soybean Oil',
  wasabi: "Edamame, Soybean Oil, Wasabi Soy Sauce Powder (Fermented Soy Sauce, Acid Hydrolyzed Vegetable Protein Seasoning, Maltodextrin, Salt, Sugar, Caramel Colour, Disodium 5'-Ribonucleotide, Yeast Extract, Onion Powder, Spice, Ginger Powder), Soybean Oil, Wasabi Powder",
  ranch: 'Edamame, Ranch Seasoning (Salt, Cane Sugar, Garlic Powder, Maltodextrin, Onion Powder, Spices, Tomato Powder, Natural Flavors, 2% or less of Lactic Acid Powder, Citric Acid, Yeast Extract), Soybean Oil',
};
class FlavorBuilder extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.once = this.dataset.mode === 'once';
    const params = new URLSearchParams(location.search);
    const quantity = Number(params.get('quantity'));
    this.minimum = this.once ? 1 : Number.isInteger(quantity) && quantity >= 2 && quantity <= 10 ? quantity : 2;
    this.from = ['offer','glp1'].includes(params.get('from')) ? params.get('from') : 'offer';
    this.rows = [...this.querySelectorAll('[data-flavor]')];
    this.selection = Object.fromEntries(FLAVORS.map(id => [id,0]));
    const back = new URL(this.from === 'glp1' ? '/pages/reasons' : '/pages/offer',location.origin);
    if (location.pathname === '/pages/find-us') {
      back.pathname = location.pathname;
      back.searchParams.set('view',this.from);
    }
    back.hash = 'build-your-box';
    for (const [key,value] of params) if(key.startsWith('utm_') || ['gclid','fbclid','preview_theme_id','pb'].includes(key)) back.searchParams.set(key,value);
    this.querySelector('[data-builder-back]').href = back.href;
    this.dialog = this.querySelector('dialog');
    this.addEventListener('click',event => {
      const control = event.target.closest('[data-change]');
      if(control && !control.disabled) this.change(control.closest('[data-flavor]').dataset.variant,Number(control.dataset.change));
      if(event.target.closest('[data-builder-checkout]')) this.checkout();
      if(event.target.closest('[data-builder-retry]')) this.loadCatalog();
      const facts = event.target.closest('[data-facts]');
      if(facts) this.openFacts(facts.dataset.facts);
      if(event.target.closest('[data-close-facts]') || event.target === this.dialog) this.dialog.close();
      if(event.target.closest('[data-facts-add]')) {this.change(this.factsVariant,1);this.dialog.close();}
    });
    this.handlePageShow = () => {this.busy=false;this.changed();};
    window.addEventListener('pageshow',this.handlePageShow);
    if(!this.once) {
      this.handleScroll = () => {if(scrollY+innerHeight>=document.documentElement.scrollHeight*.8)this.activateCheckout();};
      window.addEventListener('scroll',this.handleScroll,{passive:true});
      const date=new Date();const day=date.getDate();const ordinal=day%100>=11&&day%100<=13?'th':({1:'st',2:'nd',3:'rd'}[day%10] || 'th');
      this.querySelector('[data-stock-date]').textContent=`${date.toLocaleString('en-US',{month:'short'})}. ${day}${ordinal}`;
      const stock = this.querySelector('.os-flavor-builder__stock');
      this.stockResize = new ResizeObserver(([entry]) => {
        if (entry.contentRect.width === this.stockWidth) return;
        this.stockWidth = entry.contentRect.width;
        this.fitStockMessage();
      });
      this.stockResize.observe(stock);
      document.fonts.ready.then(() => { if (this.isConnected) this.fitStockMessage(); });
    }
    this.render();this.loadCatalog();
  }
  disconnectedCallback() {this.stockResize?.disconnect();clearTimeout(this.timer);this.revision++;window.removeEventListener('pageshow',this.handlePageShow);window.removeEventListener('scroll',this.handleScroll);}
  fitStockMessage() {
    const text = this.querySelector('[data-stock-message]');
    const width = text.parentElement.clientWidth;
    if (!width) return;
    text.style.fontSize = '16px';
    const measured = text.getBoundingClientRect().width;
    if (measured) text.style.fontSize = `${16 * (width - 0.5) / measured}px`;
  }
  openFacts(key) {
    const template=this.querySelector(`[data-facts-template="${key}"]`);
    this.querySelector('[data-facts-content]').replaceChildren(template.content.cloneNode(true));
    this.querySelector('[data-ingredients]').textContent=INGREDIENTS[key];
    this.factsVariant=this.rows.find(row=>row.dataset.flavor===key).dataset.variant;
    this.querySelector('[data-facts-add]').disabled=!this.available?.has(this.factsVariant) || (!this.once && this.count()>=10);
    this.dialog.showModal();
  }
  count() {return Object.values(this.selection).reduce((a,b)=>a+b,0);}
  change(id,amount) {
    if(this.busy || !this.ready || !FLAVORS.includes(id))return;
    const next=this.selection[id]+amount;
    if(next<0 || (!this.once && this.count()+amount>10) || (amount>0 && !this.available.has(id)))return;
    this.selection[id]=next;if(amount>0)this.activateCheckout();this.changed();
  }
  activateCheckout() {
    if(this.once)return;
    this.querySelector('[data-builder-checkout-holder]').classList.add('is-active');
    window.removeEventListener('scroll',this.handleScroll);
  }
  async loadCatalog() {
    this.error('');
    try {
      const data=await request(CATALOG,{ids:FLAVORS.map(id=>gid('ProductVariant',id))});
      this.available=new Set(data.nodes.filter(n=>n?.availableForSale).map(n=>n.id.split('/').pop()));
      this.ready=true;this.changed();
    } catch(error) {this.ready=false;this.render();this.error(error.message);}
  }
  changed() {
    this.revision=(this.revision || 0)+1;this.cart=null;this.error('');clearTimeout(this.timer);this.render();
    if(this.count()>=this.minimum && this.ready)this.timer=setTimeout(()=>{this.pending=this.quote(this.revision);},350);
  }
  error(message) {
    const node=this.querySelector('[data-builder-error]');node.textContent=message;node.hidden=!message;
    this.querySelector('[data-builder-retry]').hidden=!message;
  }
  render() {
    const count=this.count();const state=selectionState(count,this.minimum,this.once);
    this.rows.forEach(row=>{
      const n=this.selection[row.dataset.variant];row.querySelector('[data-flavor-count]').textContent=n;
      row.querySelector('[data-change="-1"]').disabled=this.busy || n===0;
      const plus=row.querySelector('[data-change="1"]');
      plus.disabled=this.busy || !this.ready || !this.available?.has(row.dataset.variant) || (!this.once && count>=10);
      plus.title=this.ready && !this.available.has(row.dataset.variant)?'Currently sold out':'';
    });
    if(this.once) {
      const shipping=this.querySelector('[data-builder-shipping]');
      shipping.querySelector('[data-builder-shipping-text]').textContent=count>=3?"You've Unlocked FREE Shipping!":`You're ${3-count} ${3-count===1?'box':'boxes'} away from free shipping`;
      shipping.classList.toggle('is-active',count>=3);
      this.querySelectorAll('[data-savings-tier]').forEach(node=>{
        const tier=Number(node.dataset.savingsTier);
        node.classList.toggle('is-active',count>=tier);
        node.style.setProperty('--progress',`${Math.min(100,Math.max(0,count-tier)*50)}%`);
      });
    } else {
      const quantity=state.displayQuantity;
      this.querySelector('[data-builder-total]').textContent=this.money(this.cart?this.cart.cost.totalAmount.amount:TOTALS[quantity]);
      this.querySelector('[data-builder-compare]').textContent=this.money(COMPARE[quantity]);
      this.querySelector('[data-builder-saving]').textContent=`You're saving ${SAVINGS[quantity]}%${quantity>=3?' + Free Shipping':''}`;
      this.querySelector('[data-builder-count]').textContent=state.counter;
      this.querySelectorAll('[data-offer-gift]').forEach(el=>{el.querySelector('.os-gift-buybox__lock').hidden=count>=Number(el.dataset.offerGift);});
      const value=GIFTS.filter(g=>count>=g.minimum).reduce((sum,g)=>sum+g.value,0);
      this.querySelector('[data-offer-gift-value]').textContent=`${this.money(value)} of Gifts With Your First Order! 🎁`;
    }
    this.querySelector('[data-builder-label]').textContent=this.busy?'Applying Discounts...':state.label;
    this.querySelector('[data-builder-checkout]').disabled=this.busy || !this.ready || !state.valid;
    this.querySelector('[data-builder-arrow]').hidden=!state.valid;
  }
  money(value) {return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(Number(value));}
  async quote(revision) {
    try {
      const attributes=[{key:'pageName',value:this.once?'lp008-ot':'lp008'},{key:'sourcePage',value:this.from},{key:'currentUrl',value:location.href},{key:'environment',value:this.dataset.preview==='main'?'production':'preview'}];
      if(window.igData?.user?.igId)attributes.push({key:'igId',value:window.igData.user.igId});
      const params=new URLSearchParams(location.search);
      for(const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid'])if(params.get(key))attributes.push({key,value:params.get(key)});
      const input=buildCartInput(this.selection,this.dataset.mode,this.minimum,attributes);
      const data=await request(CART_CREATE,{input});
      if(revision!==this.revision || !this.isConnected)return;
      if(data.cartCreate.userErrors.length)throw new Error(data.cartCreate.userErrors.map(e=>e.message).join(' '));
      this.cart=validateCart(data.cartCreate.cart,input);this.render();
    } catch(error) {if(revision!==this.revision)return;this.cart=null;this.error(error.message);}
  }
  async checkout() {
    if(this.busy || !this.ready || this.count()<this.minimum)return;
    this.busy=true;this.render();clearTimeout(this.timer);
    if(!this.cart)await this.quote(this.revision);
    if(!this.cart){this.busy=false;this.render();return;}
    const items=this.rows.filter(row=>this.selection[row.dataset.variant]).map(row=>({item_id:row.dataset.variant,item_name:row.dataset.name,quantity:this.selection[row.dataset.variant]}));
    window.dataLayer=window.dataLayer || [];
    window.dataLayer.push({event:'begin_checkout',ecommerce:{currency:'USD',value:Number(this.cart.cost.totalAmount.amount),items},funnel:this.from,purchase_mode:this.dataset.mode});
    location.assign(this.cart.checkoutUrl);
  }
}
if(typeof customElements!=='undefined' && !customElements.get('os-flavor-builder'))customElements.define('os-flavor-builder',FlavorBuilder);
